import { render, staticRenderFns } from "./MasterCampaignEmail.vue?vue&type=template&id=6bbb1de8&"
import script from "./MasterCampaignEmail.vue?vue&type=script&lang=js&"
export * from "./MasterCampaignEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports